import { render, staticRenderFns } from "./tab1.vue?vue&type=template&id=db2c6f88&scoped=true&"
import script from "./tab1.vue?vue&type=script&lang=js&"
export * from "./tab1.vue?vue&type=script&lang=js&"
import style0 from "./tab1.vue?vue&type=style&index=0&id=db2c6f88&prod&scoped=true&lang=css&"
import style1 from "./tab1.vue?vue&type=style&index=1&id=db2c6f88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c6f88",
  null
  
)

export default component.exports